__turbopack_context__.v({
  "CloseSwiper": "media-slider-module__SO5zZa__CloseSwiper",
  "SwiperContainer": "media-slider-module__SO5zZa__SwiperContainer",
  "SwiperMedia": "media-slider-module__SO5zZa__SwiperMedia",
  "display": "media-slider-module__SO5zZa__display",
});
